import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {

    ObterAvaliacoesDespesas() {
        return axiosJwt
            .get(`${api}/despesasgerais/demandantes/despesas/avaliacoes`)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    obterTodos(filtro) {
        return axiosJwt
            .get(`${api}/despesasgerais/demandantes/despesas?status=${filtro.status != null ? filtro.status : ''}`)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    obterFiltros() {
        return axiosJwt
            .get(`${api}/despesasgerais/demandantes/despesas/filtros`)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    obterPorId(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/demandantes/despesas/${despesaId}`)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    obterPerguntas() {
        return axiosJwt
            .get(`${api}/despesasgerais/demandantes/despesas/perguntas`)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    obterTiposRespostas() {
        return axiosJwt
            .get(`${api}/despesasgerais/demandantes/despesas/respostas`)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    aprovar(despesaId, avaliacoesDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/demandantes/despesas/${despesaId}/aprovar`, avaliacoesDto)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    reprovar(despesaId, justificativaDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/demandantes/despesas/${despesaId}/reprovar`, justificativaDto)
            .then(response => {
                return response.data
            })
            .catch( error => {
                return errorHandler(error)
            })
    },

    obterErroComprometimento(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/demandantes/despesas/${despesaId}/errocomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/demandantes/despesas/${despesaId}/historico`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/demandantes/despesas/${despesaId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterRelatorio(modulo, codigo) {
        let url = `${api}/relatorios?m=${modulo}&c=${codigo}`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }

}
